import React from 'react';
import { Container, Card, Tab, Box, Tabs } from '@mui/material';

import Page from '../../components-core/Page';
import Iconify from '../../components-core/Iconify';
import { useSettings } from '../../services/hooks';
import { ParticipantRecord } from '../../sections/employee/record/ParticipantRecord';
import { PurchaserRecord } from '../../sections/employee/record/PurchaserRecord';
import { ResortRecord } from '../../sections/employee/record/ResortRecord';
import { CampRecord } from '../../sections/employee/record/CampRecord';
import { EventRecord } from '../../sections/employee/record/EventRecord';
import { AccomodationRecord } from '../../sections/employee/record/AccomodationRecord';
import { AgeRangeRecord } from '../../sections/employee/record/AgeRangeRecord';
import { SeasonRecord } from '../../sections/employee/record/SeasonRecord';
import { PromotionRecord } from '../../sections/employee/record/PromotionRecord';
import { TransportRecord } from '../../sections/employee/record/TransportRecord';

import DateRangeIcon from '@mui/icons-material/DateRange';

export const Record = () => {
  const { themeStretch } = useSettings();
  const [currentTab, setCurrentTab] = React.useState('zajęcia');

  const ACCOUNT_TABS = [
    {
      value: 'zajęcia',
      icon: <DateRangeIcon />,
      component: <EventRecord />
    },
    // {
    //   value: 'turnusy',
    //   icon: <Iconify icon={'ic:baseline-campaign'} width={20} height={20} />,
    //   component: <CampRecord />
    // },
    {
      value: 'ośrodki',
      icon: <Iconify icon={'ic:baseline-place'} width={20} height={20} />,
      component: <ResortRecord />
    },
    // {
    //   value: 'sezony',
    //   icon: <Iconify icon={'ic:baseline-cloud'} width={20} height={20} />,
    //   component: <SeasonRecord />
    // },
    // {
    //   value: 'zakwaterowania',
    //   icon: <Iconify icon={'ic:baseline-house'} width={20} height={20} />,
    //   component: <AccomodationRecord />
    // },
    // {
    //   value: 'promocje',
    //   icon: <Iconify icon={'ic:baseline-discount'} width={20} height={20} />,
    //   component: <PromotionRecord />
    // },
    // {
    //   value: 'przedziały wiekowe',
    //   icon: <Iconify icon={'ic:baseline-date-range'} width={20} height={20} />,
    //   component: <AgeRangeRecord />
    // },
    // {
    //   value: 'transporty',
    //   icon: <Iconify icon={'ic:baseline-directions-bus'} width={20} height={20} />,
    //   component: <TransportRecord />
    // },
    {
      value: 'zamawiający',
      icon: <Iconify icon={'ic:round-account-box'} width={20} height={20} />,
      component: <PurchaserRecord />
    },
    {
      value: 'uczestnicy',
      icon: <Iconify icon={'ic:baseline-co-present'} width={20} height={20} />,
      component: <ParticipantRecord />
    }
  ];

  return (
    <Page title="Kartoteki">
      <Card sx={{ height: { md: '120vh' }, display: { md: 'flex' }, flexDirection: 'column' }}>
        <Box p={1}>
          <Tabs
            value={currentTab}
            scrollButtons="auto"
            variant="scrollable"
            allowScrollButtonsMobile
            onChange={(e, value) => setCurrentTab(value)}
            sx={{ mb: 1 }}
          >
            {ACCOUNT_TABS.map(tab => (
              <Tab disableRipple key={tab.value} label={tab.value} icon={tab.icon} value={tab.value} />
            ))}
          </Tabs>
        </Box>

        {ACCOUNT_TABS.map(tab => {
          const isMatched = tab.value === currentTab;

          return isMatched && <div key={tab.value}>{tab.component}</div>;
        })}
      </Card>
    </Page>
  );
};
